var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-doc-mgmt-dialog',
    !_vm.isConfirmation ? 'asc-doc-mgmt-dialog--unsaved' : '' ]},[_c('asc-dialog',{attrs:{"show-dialog":_vm.showDialog,"text":_vm.dialogTitle,"on-primary":_vm.handleSaveExitSession,"on-secondary":_vm.handleContinueSession,"secondary-button-text":_vm.secondaryButtonText,"primary-button-text":_vm.primaryButtonText}},[_vm._v(_vm._s(_vm.dialogText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }